
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PolitiqueConfidentialitePage() {
  const sections = [
    {
      title: '1. Introduction',
      content: 'Pixel-anim accorde une grande importance à la protection de vos données personnelles. Cette Politique de Confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos informations personnelles conformément au Règlement Général sur la Protection des Données (RGPD).'
    },
    {
      title: '2. Responsable du Traitement',
      content: 'Le responsable du traitement des données est Pixel-anim, joignable à l\'adresse email : contact@pixel-anim.com. Pour toute question relative à la protection de vos données personnelles, vous pouvez nous contacter à cette adresse.'
    },
    {
      title: '3. Données Collectées',
      content: 'Nous collectons les données suivantes : informations d\'identification (nom, prénom, email), informations de paiement (traitées de manière sécurisée par Stripe), informations de personnalisation (photos, textes, préférences pour vos créations), données de navigation (cookies, adresse IP, pages visitées), et correspondances (emails, messages via formulaire de contact).'
    },
    {
      title: '4. Finalités du Traitement',
      content: 'Vos données sont utilisées pour : traiter et livrer vos commandes, créer vos produits personnalisés, gérer les paiements et la facturation, communiquer avec vous concernant vos commandes, améliorer nos services et votre expérience utilisateur, respecter nos obligations légales et réglementaires, et vous envoyer des informations marketing (avec votre consentement).'
    },
    {
      title: '5. Base Légale du Traitement',
      content: 'Le traitement de vos données repose sur : l\'exécution du contrat (traitement de vos commandes), votre consentement (newsletter, cookies non essentiels), nos intérêts légitimes (amélioration de nos services, sécurité), et le respect d\'obligations légales (comptabilité, fiscalité).'
    },
    {
      title: '6. Partage des Données',
      content: 'Nous ne vendons jamais vos données personnelles. Nous pouvons partager vos données avec : Stripe (traitement des paiements), nos prestataires techniques (hébergement, email), nos créateurs (uniquement les informations nécessaires à la personnalisation), et les autorités légales (si requis par la loi).'
    },
    {
      title: '7. Durée de Conservation',
      content: 'Nous conservons vos données : pendant la durée de la relation commerciale, 3 ans après votre dernière commande (données clients), 10 ans pour les données comptables et fiscales, et jusqu\'à votre demande de suppression pour les données marketing (avec votre consentement).'
    },
    {
      title: '8. Vos Droits',
      content: 'Conformément au RGPD, vous disposez des droits suivants : droit d\'accès à vos données, droit de rectification des données inexactes, droit à l\'effacement (droit à l\'oubli), droit à la limitation du traitement, droit à la portabilité de vos données, droit d\'opposition au traitement, et droit de retirer votre consentement à tout moment. Pour exercer ces droits, contactez-nous à contact@pixel-anim.com.'
    },
    {
      title: '9. Sécurité des Données',
      content: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : chiffrement SSL/TLS pour les transmissions, stockage sécurisé des données, accès limité aux données (principe du moindre privilège), sauvegardes régulières, et surveillance continue de la sécurité.'
    },
    {
      title: '10. Cookies',
      content: 'Notre site utilise des cookies pour : assurer le fonctionnement du site (cookies essentiels), analyser le trafic et améliorer l\'expérience (cookies analytiques), et personnaliser le contenu (cookies de préférence). Vous pouvez gérer vos préférences de cookies via les paramètres de votre navigateur.'
    },
    {
      title: '11. Transferts Internationaux',
      content: 'Vos données sont principalement stockées au sein de l\'Union Européenne. Si un transfert hors UE est nécessaire, nous nous assurons que des garanties appropriées sont en place (clauses contractuelles types, Privacy Shield, etc.).'
    },
    {
      title: '12. Mineurs',
      content: 'Nos services s\'adressent aux adultes. Si vous commandez pour un enfant, vous devez être son représentant légal. Nous ne collectons pas sciemment de données personnelles d\'enfants de moins de 16 ans sans le consentement des parents.'
    },
    {
      title: '13. Modifications',
      content: 'Nous pouvons modifier cette Politique de Confidentialité à tout moment. Les modifications seront publiées sur cette page avec une nouvelle date de mise à jour. Nous vous encourageons à consulter régulièrement cette page.'
    },
    {
      title: '14. Réclamations',
      content: 'Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de l\'Informatique et des Libertés (CNIL) : www.cnil.fr'
    },
    {
      title: '15. Contact',
      content: 'Pour toute question concernant cette Politique de Confidentialité ou l\'exercice de vos droits, contactez-nous à : contact@pixel-anim.com. Nous nous engageons à répondre dans un délai maximum de 30 jours.'
    }
  ];

  // Error handling for missing components
  if (!Navbar || !Footer) {
    console.error('Required components (Navbar or Footer) are not available');
  }

  return (
    <div className="min-h-screen bg-white">
      {Navbar && <Navbar />}

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-5xl md:text-6xl font-fredoka font-bold text-gray-900 mb-6">
              Politique de{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                Confidentialité
              </span>
            </h1>
            <p className="text-lg font-quicksand text-gray-600 max-w-3xl mx-auto">
              Dernière mise à jour : Janvier 2025
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-4xl p-8 md:p-12 shadow-soft border border-gray-100"
          >
            {/* Important Notice */}
            <div className="mb-8 p-6 bg-gradient-to-br from-primary-mint/20 to-green-100 rounded-3xl">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-mint rounded-2xl flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-2">
                    Votre vie privée est importante
                  </h3>
                  <p className="font-quicksand text-gray-700">
                    Nous nous engageons à protéger vos données personnelles et à respecter votre vie privée conformément au RGPD.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  className="border-b border-gray-100 pb-6 last:border-b-0"
                >
                  <h2 className="text-2xl font-fredoka font-bold text-gray-900 mb-4">
                    {section.title}
                  </h2>
                  <p className="font-quicksand text-gray-700 leading-relaxed">
                    {section.content}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="mt-12 p-6 bg-gradient-to-br from-primary-coral/20 to-pink-100 rounded-3xl"
            >
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Questions sur vos données ?
              </h3>
              <p className="font-quicksand text-gray-700 mb-4">
                Notre équipe est à votre disposition pour répondre à toutes vos questions concernant la protection de vos données personnelles.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                <span>Nous contacter</span>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {Footer && <Footer />}
    </div>
  );
}
